import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DynamicCarDropdownState, Option } from "../type";

const initialState: DynamicCarDropdownState = {
  currentPolicyTypes: [],
  currentInsurers: [],
  noClaimCertificates: [],
};

const dynamicCarDropdownSlice = createSlice({
  name: "dynamicCarDropdown",
  initialState,
  reducers: {
    setCurrentPolicyTypes: (state, action: PayloadAction<Option[]>) => {
      state.currentPolicyTypes = action.payload;
    },
    setCurrentInsurers: (state, action: PayloadAction<Option[]>) => {
      state.currentInsurers = action.payload;
    },
    setNoClaimCertificates: (state, action: PayloadAction<Option[]>) => {
      state.noClaimCertificates = action.payload;
    },
  },
});

export const { setCurrentPolicyTypes, setCurrentInsurers, setNoClaimCertificates } =
  dynamicCarDropdownSlice.actions;

export const { reducer: dynamicCarDropdownReducer } = dynamicCarDropdownSlice;
